import {
    GET_SUPPORT,
    GET_SUPPORT_FAIL,
    GET_SUPPORT_SUCCESS,
    GET_SUPPORT_DETAILS,
    GET_SUPPORT_DETAILS_FAIL,
    GET_SUPPORT_DETAILS_SUCCESS,
    ADD_NEW_SUPPORT,
    ADD_SUPPORT_SUCCESS,
    ADD_SUPPORT_FAIL,
    UPDATE_SUPPORT,
    UPDATE_SUPPORT_SUCCESS,
    UPDATE_SUPPORT_FAIL,
    DELETE_SUPPORT,
    DELETE_SUPPORT_SUCCESS,
    DELETE_SUPPORT_FAIL,
    RESET_SUPPORT_STATE,
    EXPORT_SUPPORT,
    EXPORT_SUPPORT_SUCCESS,
    EXPORT_SUPPORT_FAIL,
    RESET_SUPPORT_ATTACHMENT_STATE
  } from "./actionTypes";
  
  export const getSupport = support => ({
    type: GET_SUPPORT,
    payload: support,
  });
  
  export const getSupportSuccess = support => ({
    type: GET_SUPPORT_SUCCESS,
    payload: support,
  });
  
  export const getSupportFail = error => ({
    type: GET_SUPPORT_FAIL,
    payload: error,
  });

  export const getSupportDetails = ({id}) => ({
    type: GET_SUPPORT_DETAILS,
    payload: {id},
  });
  
  export const getSupportDetailsSuccess = support => ({
    type: GET_SUPPORT_DETAILS_SUCCESS,
    payload: support,
  });
  
  export const getSupportDetailsFail = error => ({
    type: GET_SUPPORT_DETAILS_FAIL,
    payload: error,
  });
  
  //add 
  export const addNewSupport = support => ({
    type: ADD_NEW_SUPPORT,
    payload: support,
  });
  
  export const addSupportSuccess = support => ({
    type: ADD_SUPPORT_SUCCESS,
    payload: support,
  });
  
  export const addSupportFail = error => ({
    type: ADD_SUPPORT_FAIL,
    payload: error,
  });
  
  //update 
  export const updateSupport =({id, support}) => ({
    type: UPDATE_SUPPORT,
    payload:{id, support},
  });
  
  export const updateSupportSuccess = support => ({
    type: UPDATE_SUPPORT_SUCCESS,
    payload: support,
  });
  
  export const updateSupportFail = error => ({
    type: UPDATE_SUPPORT_FAIL,
    payload: error,
  });
  
  //delete 
  export const deleteSupport =({id}) => ({
    type: DELETE_SUPPORT,
    payload:{id},
  });
  
  export const deleteSupportSuccess = support => ({
    type: DELETE_SUPPORT_SUCCESS,
    payload: support,
  });
  
  export const deleteSupportFail = error => ({
    type: DELETE_SUPPORT_FAIL,
    payload: error,
  });
  
  // export
  export const exportSupport = (payload) => ({
    type: EXPORT_SUPPORT,
    payload: payload,
  });

  export const exportSupportSuccess = support => ({
    type: EXPORT_SUPPORT_SUCCESS,
    payload: support,
  });

  export const exportSupportFail = error => ({
    type: EXPORT_SUPPORT_FAIL,
    payload: error,
  });

  //reset
  export const resetSupportState = () => {
    return {
        type: RESET_SUPPORT_STATE,
    }
  }

  //reset attachment
  export const resetSupportAttachmentState = () => {
    return {
        type: RESET_SUPPORT_ATTACHMENT_STATE,
    }
  }
  
  